import React from "react";
import { Femenino, Masculino } from "../../utils/IconsSVG";

export const ContainerPersona = ({ item }) => {
  const { sexo } = item;

  return (
    <div>
      {sexo === undefined ||sexo === null ? <>—</> : sexo ==="M" ?<Masculino /> : <Femenino />  }
    </div>
  );
};

